<div class="tool-content-container">
  <div class="tool-description">
    Select an
    <instruction-step-link
      link="admit-type"
      text="Admit Type"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />, an
    <instruction-step-link
      link="associate-degree"
      text="Associate Degree"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />, the
    <instruction-step-link
      link="full-part-time-ind"
      text="Full/Part-Time Indicator"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />, a Graduation Time [Default: Three-Year]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Two-year or three-year graduation"
      matTooltipPosition="right"
    ></i
    >, a College [Default: All]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    >, a Department [Default: All]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    >, a
    <instruction-step-link
      link="program"
      text="Program"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />, a
    <instruction-step-link
      link="transfer-college-name"
      text="Transfer College Name"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />, and click submit the button to generate results for Transfer Enrollment
    and Trends

    <!-- <b class="instructions-title"
      >To generate results for Transfer Enrollment and Trends:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="admit-type"
      text="Admit Type"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="associate-degree"
      text="Associate Degree"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="full-part-time-ind"
      text="Full/Part-Time Indicator"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />
    <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select Graduation Time
    [Default: Three-Year]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Two-year or three-year graduation"
      matTooltipPosition="right"
    ></i>
    <br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Select College [Default: All]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i>
    <br />
    Step 6 <i class="fa-solid fa-arrow-right"></i> Select Department [Default:
    All]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 7 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="program"
      text="Program"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />
    <br />
    Step 8 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link
      link="transfer-college-name"
      text="Transfer College Name"
      tooltipMessage="Default gives all possible values."
      appendedText="[Default: All]"
    />
    <br />
    Step 9 <i class="fa-solid fa-arrow-right"></i> Click on the submit button -->
  </div>

  <div
    *ngIf="transferStudents"
    class="chartjs-container"
    [class.mat-elevation-z8]="true"
  >
    <div class="chart-title-with-btn-icon">
      <span>Enrollment Trends for Transfer Students</span>
      <button
        matTooltip="Save chart as image"
        mat-icon-button
        aria-label="Chart snap icon"
        (click)="
          dataService.exportChartJsAsPNG(
            'enrollment-trends-chart',
            'enrollment-trends-chart'
          )
        "
      >
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
    <canvas id="enrollment-trends-chart">{{ enrollmentTrendsChart }}</canvas>
  </div>

  <div
    *ngIf="transferStudents"
    class="chartjs-container"
    [class.mat-elevation-z8]="true"
  >
    <div class="chart-title-with-btn-icon">
      <span>Retention Trends (Fall-to-Fall)</span>
      <button
        matTooltip="Save chart as image"
        mat-icon-button
        aria-label="Chart snap icon"
        (click)="
          dataService.exportChartJsAsPNG(
            'retention-trends-chart',
            'retention-trends-chart'
          )
        "
      >
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
    <canvas id="retention-trends-chart">{{ retentionTrendsChart }}</canvas>
  </div>

  <div
    *ngIf="transferStudents"
    class="chartjs-container"
    [class.mat-elevation-z8]="true"
  >
    <div class="chart-title-with-btn-icon">
      <span>Graduation Rates</span>
      <button
        matTooltip="Save chart as image"
        mat-icon-button
        aria-label="Chart snap icon"
        (click)="
          dataService.exportChartJsAsPNG(
            'graduation-rates-chart',
            'graduation-rates-chart'
          )
        "
      >
        <mat-icon>photo_camera</mat-icon>
      </button>
    </div>
    <canvas id="graduation-rates-chart">{{ graduationRatesChart }}</canvas>
  </div>
</div>
